/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';
import config from '../config/sidebarItems.config.json';
import jwt_decode from 'jwt-decode';
import { USER_LEVEL } from '@/config/userManagement.config';

export interface IWhoamiMethods extends IPluginMethodMap {
  whoami(args: any): Promise<any>;
}

export class WhoamiService implements IAgentPlugin {
  readonly methods: IWhoamiMethods;

  constructor() {
    this.methods = {
      whoami: this.whoami.bind(this),
    };
  }

  async whoami(args: any) {
    let _token = this.checkValidToken();
    console.log('token in checkValidToken', _token);
    if (_token?.valid && _token?.token && _token?.role) {
      return { whoami: _token.role };
    } else {
      //TODO: FIX ME
      return { whoami: '' };
    }
    // return { whoami: 'platformOwner' };
  }

  private checkValidToken() {
    const storageSrv = StorageModule.getInstance();
    let _sessionToken = storageSrv.get('userProfile', 'session');
    let _localToken = storageSrv.get('userProfile', 'local');
    let _userToken = _sessionToken ?? _localToken;
    console.log('role in 22', _userToken);
    let _role =
      _userToken &&
      _userToken?.userRoles[0]?.uuid === '2324e90f-6843-48e0-8f70-84ca5461a0de'
        ? _userToken?.orgRoles[0]?.org?.orgRole === 'ISSUER'
          ? 'issuer'
          : 'platform_owner'
        : _userToken?.orgRoles[0]?.org?.orgRole === 'ISSUER'
        ? 'issuer'
        : _userToken?.currentRole ?? _userToken?.userRoles[0]?.name;
    console.log(
      'role in checkValidToken',
      _role,
      _userToken,
      _userToken?.userRoles[0]?.uuid === '2324e90f-6843-48e0-8f70-84ca5461a0de'
        ? _userToken?.orgRole === 'ISSUER'
          ? 'issuer'
          : 'platform_owner'
        : _userToken?.orgRole === 'ISSUER'
        ? 'issuer'
        : _userToken?.currentRole ?? _userToken?.userRoles[0]?.name
    );
    let _token = _userToken?.accessToken;
    //
    if (_token) {
      let decodedToken: any = jwt_decode(_token);
      console.log(decodedToken);
      let currentDate = new Date();
      if (decodedToken?.exp * 1000 < currentDate.getTime()) {
        return {
          valid: false,
          role: null,
          token: _token,
        };
      } else {
        return {
          valid: true,
          role: _role ?? decodedToken?.currentRole?.name,
          // role: decodedToken?.currentRole?.name,
          token: _token,
        };
      }
    } else {
      return {
        valid: true,
        role: null,
        token: null,
      };
    }
  }
}
